module.exports = __webpack_public_path__ + "static/media/remove.1a3a17c9.svg";